import React from 'react'
import WithThemeContext from '../WithThemeContext'
import Logo from '../Logo'

const GameLogo = ({ gameParams: { logo } }) => (
  <Logo imgUrl={logo} />
)

export default WithThemeContext(GameLogo)